import * as firebase from 'firebase/app';
import 'firebase/auth';
import { useContext } from 'react';
import * as React from 'react';

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
});

export const FirebaseApp = React.createContext<firebase.FirebaseApp>(app);

export function useFirebaseApp() {
  return useContext(FirebaseApp);
}
